export default __webpack_public_path__ + "static/about-ekko-bg-desktop-16db6207c6ef14e406669a226a3a6990.jpg";